/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentTypeOrderRequest,
  AppointmentTypeRequest,
  AppointmentTypeResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentTypeOrderRequestFromJSON,
    AppointmentTypeOrderRequestToJSON,
    AppointmentTypeRequestFromJSON,
    AppointmentTypeRequestToJSON,
    AppointmentTypeResponseFromJSON,
    AppointmentTypeResponseToJSON,
} from '../models/index';

export interface AddAppointmentTypeRequest {
    instituteId: string;
    appointmentTypeRequest: AppointmentTypeRequest;
    doctorId?: string;
}

export interface GetNextOrderRequest {
    instituteId: string;
    doctorId?: string;
}

export interface ListAppointmentTypesRequest {
    instituteId: string;
    doctorId?: string;
    isSetting?: boolean;
}

export interface UpdateActiveAppointmentTypeRequest {
    instituteId: string;
    appointmentTypeId: string;
}

export interface UpdateAppointmentTypeRequest {
    instituteId: string;
    appointmentTypeId: string;
    appointmentTypeRequest: AppointmentTypeRequest;
}

export interface UpdateAppointmentTypeOrderRequest {
    instituteId: string;
    appointmentTypeOrderRequest: Array<AppointmentTypeOrderRequest>;
}

/**
 * 
 */
export class AppointmentTypeApi extends runtime.BaseAPI {

    /**
     * Add an appointment type
     */
    async addAppointmentTypeRaw(requestParameters: AddAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentTypeResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addAppointmentType().'
            );
        }

        if (requestParameters['appointmentTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeRequest',
                'Required parameter "appointmentTypeRequest" was null or undefined when calling addAppointmentType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/appointment-types`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentTypeRequestToJSON(requestParameters['appointmentTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeResponseFromJSON(jsonValue));
    }

    /**
     * Add an appointment type
     */
    async addAppointmentType(requestParameters: AddAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentTypeResponse> {
        const response = await this.addAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get next order value
     */
    async getNextOrderRaw(requestParameters: GetNextOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getNextOrder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/appointment-types/next-order`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get next order value
     */
    async getNextOrder(requestParameters: GetNextOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getNextOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all appointment types
     */
    async listAppointmentTypesRaw(requestParameters: ListAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentTypeResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listAppointmentTypes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctor_id'] = requestParameters['doctorId'];
        }

        if (requestParameters['isSetting'] != null) {
            queryParameters['is_setting'] = requestParameters['isSetting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/appointment-types`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentTypeResponseFromJSON));
    }

    /**
     * Lists all appointment types
     */
    async listAppointmentTypes(requestParameters: ListAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentTypeResponse>> {
        const response = await this.listAppointmentTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the active field of an appointment type
     */
    async updateActiveAppointmentTypeRaw(requestParameters: UpdateActiveAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentTypeResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateActiveAppointmentType().'
            );
        }

        if (requestParameters['appointmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeId',
                'Required parameter "appointmentTypeId" was null or undefined when calling updateActiveAppointmentType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/active-appointment-types/{appointment_type_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters['appointmentTypeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeResponseFromJSON(jsonValue));
    }

    /**
     * Update the active field of an appointment type
     */
    async updateActiveAppointmentType(requestParameters: UpdateActiveAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentTypeResponse> {
        const response = await this.updateActiveAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an appointment type
     */
    async updateAppointmentTypeRaw(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentTypeResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateAppointmentType().'
            );
        }

        if (requestParameters['appointmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeId',
                'Required parameter "appointmentTypeId" was null or undefined when calling updateAppointmentType().'
            );
        }

        if (requestParameters['appointmentTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeRequest',
                'Required parameter "appointmentTypeRequest" was null or undefined when calling updateAppointmentType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/appointment-types/{appointment_type_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters['appointmentTypeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentTypeRequestToJSON(requestParameters['appointmentTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeResponseFromJSON(jsonValue));
    }

    /**
     * Update an appointment type
     */
    async updateAppointmentType(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentTypeResponse> {
        const response = await this.updateAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the appointments order
     */
    async updateAppointmentTypeOrderRaw(requestParameters: UpdateAppointmentTypeOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateAppointmentTypeOrder().'
            );
        }

        if (requestParameters['appointmentTypeOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeOrderRequest',
                'Required parameter "appointmentTypeOrderRequest" was null or undefined when calling updateAppointmentTypeOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/appointment-types/orders`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['appointmentTypeOrderRequest']!.map(AppointmentTypeOrderRequestToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the appointments order
     */
    async updateAppointmentTypeOrder(requestParameters: UpdateAppointmentTypeOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAppointmentTypeOrderRaw(requestParameters, initOverrides);
    }

}
